import React from 'react';
import { Icon } from '../icons/Icon';
import { Link } from '../root/components/Link';
import styles from './BreadCrumbs.module.scss';

interface Props {
  items: BreadCrumb[];
  style?: React.CSSProperties;
}

export interface BreadCrumb {
  title: string;
  link?: string;
}

export const BreadCrumbs: React.FC<Props> = ({ items, style }) => {
  const allItems = [{ title: 'Home', link: '/' }, ...items];
  return (
    <div className={styles.breadCrumbs} style={style}>
      {allItems.map((breadCrumb, i) => (
        <BreadCrumb key={`breadcrumb-${i}`} {...breadCrumb} />
      ))}
    </div>
  );
};

const BreadCrumb: React.FC<BreadCrumb> = ({ link, title }) => {
  return link ? (
    <>
      <Link key={title} href={link} dataTrackLabel={title} dataTrackLocation="breadCrumb" noMargin={true}>
        {title}
      </Link>
      <Icon name={'chevron-right'} style={{ height: '11px', paddingTop: 5, paddingLeft: 5 }} />
    </>
  ) : (
    <div key={title}>{title}</div>
  );
};

export default BreadCrumbs;
